import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=72222e42&scoped=true&lang=html&"
import script from "./statistics.vue?vue&type=script&lang=js&"
export * from "./statistics.vue?vue&type=script&lang=js&"
import style0 from "./statistics.vue?vue&type=style&index=0&id=72222e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72222e42",
  null
  
)

component.options.__file = "statistics.vue"
export default component.exports